@if (customersToSelect) {
  <div class="row" class="mt-3">
    <div class="col-sm-4 offset-sm-4">
      @for (customer of customersToSelect; track customer) {
        <div class="customerSelectionContainer"
          (click)="loginIntoCustomer(customer)">
          <span class="fa-light fa-fw fa-house-user"></span> {{customer.customerName}}
        </div>
      }
    </div>
  </div>
}